/**
 * Cryptographic hash utilities using the native Web Crypto API.
 * No external dependencies required.
 */

/**
 * Computes the SHA-256 hash of an input string and returns it as a lowercase hex string.
 * Falls back to an empty string if the Web Crypto API is unavailable (e.g., HTTP without TLS in dev).
 */
export async function sha256(input: string): Promise<string> {
  try {
    if (typeof crypto === 'undefined' || !crypto.subtle) {
      return '';
    }
    const encoded = new TextEncoder().encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return '';
  }
}
